// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.s2OOziaJ8vK4aUQxqCSp{margin:auto}.XxogS2eNxeKK9U6GtWpr{font-size:11pt}`, "",{"version":3,"sources":["webpack://./src/features/error/view.scss"],"names":[],"mappings":"AAAA,sBACE,WAAA,CAGF,sBACE,cAAA","sourcesContent":[".codeContainer {\n  margin: auto;\n}\n\n.codeText {\n  font-size: 11pt;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"codeContainer": `s2OOziaJ8vK4aUQxqCSp`,
	"codeText": `XxogS2eNxeKK9U6GtWpr`
};
export default ___CSS_LOADER_EXPORT___;
